import React, { useEffect, useState } from "react";
import { Select } from "@fuegokit/react";
import { AkChevronDownIcon, AkChevronUpIcon } from "@fuegokit/fuegoicons-react";
import {
  StyledSelect,
  StyledSelectTrigger,
  StyledSelectContent,
  StyledSelectViewport,
  StyledSelectScrollButton,
  StyledSelectLabel,
  StyledSelectSeparator,
  StyledSelectItem,
} from "../StoryStyles/SelectStyles";

const StyledSelectExample = () => {
  const [domLoaded, setDomLoaded] = useState(false);

  useEffect(() => {
    setDomLoaded(true);
  }, []);
  return (
    <>
      {domLoaded && (
        <StyledSelect>
          <StyledSelectTrigger aria-label="Food">
            <Select.Value placeholder="Select a fruit…" />
            <Select.Icon UNSAFE_className="StyledSelectIcon">
              <AkChevronDownIcon />
            </Select.Icon>
          </StyledSelectTrigger>
          <Select.Portal>
            <StyledSelectContent>
              <StyledSelectScrollButton>
                <AkChevronUpIcon />
              </StyledSelectScrollButton>
              <StyledSelectViewport>
                <Select.Group>
                  <StyledSelectLabel>Fruits</StyledSelectLabel>
                  <StyledSelectItem value="apple">Apple</StyledSelectItem>
                  <StyledSelectItem value="banana">Banana</StyledSelectItem>
                  <StyledSelectItem value="blueberry">
                    Blueberry
                  </StyledSelectItem>
                  <StyledSelectItem value="grapes">Grapes</StyledSelectItem>
                  <StyledSelectItem value="pineapple">
                    Pineapple
                  </StyledSelectItem>
                </Select.Group>

                <StyledSelectSeparator />

                <Select.Group>
                  <StyledSelectLabel>Vegetables</StyledSelectLabel>
                  <StyledSelectItem value="aubergine">
                    Aubergine
                  </StyledSelectItem>
                  <StyledSelectItem value="broccoli">Broccoli</StyledSelectItem>
                  <StyledSelectItem value="carrot" disabled>
                    Carrot
                  </StyledSelectItem>
                  <StyledSelectItem value="courgette">
                    Courgette
                  </StyledSelectItem>
                  <StyledSelectItem value="leek">Leek</StyledSelectItem>
                </Select.Group>

                <StyledSelectSeparator />

                <Select.Group>
                  <StyledSelectLabel>Meat</StyledSelectLabel>
                  <StyledSelectItem value="beef">Beef</StyledSelectItem>
                  <StyledSelectItem value="chicken">Chicken</StyledSelectItem>
                  <StyledSelectItem value="lamb">Lamb</StyledSelectItem>
                  <StyledSelectItem value="pork">Pork</StyledSelectItem>
                </Select.Group>
              </StyledSelectViewport>
              <StyledSelectScrollButton>
                <AkChevronDownIcon />
              </StyledSelectScrollButton>
            </StyledSelectContent>
          </Select.Portal>
        </StyledSelect>
      )}
    </>
  );
};
export default StyledSelectExample;
